import React from "react";
import styles from "./DestinationPopup.css";

interface Props {
  destination: string;
}

export const DestinationPopup: React.FC<Props> = props => (
  <div className={styles.container}>
    <div className={styles.titleContainer}>Destino</div>
    <div className={styles.addressContainer}>{props.destination}</div>
  </div>
);
